import { createSelector } from '@reduxjs/toolkit'
import PRODUCT_DEVELOPMENT_STATES from 'constants/productDevelopment'

export const productLockedSelector = (name) => {
  return createSelector(
    (state) => state.productDevelopment.data,
    (products) =>
      products.find(
        (product) => product.name === name && product.status === PRODUCT_DEVELOPMENT_STATES.locked
      )
  )
}

export const productNotDevelopingSelector = (name) => {
  return createSelector(
    (state) => state.productDevelopment.data,
    (products) =>
      products.find(
        (product) =>
          product.name === name &&
          product.status === PRODUCT_DEVELOPMENT_STATES.readyToDevelop &&
          product.quarters_to_develop === 0
      )
  )
}

export const productDevelopingSelector = (name) => {
  return createSelector(
    (state) => state.productDevelopment.data,
    (products) =>
      products.find(
        (product) =>
          product.name === name &&
          product.status === PRODUCT_DEVELOPMENT_STATES.readyToDevelop &&
          product.quarters_to_develop > 0
      )
  )
}

export const productDevelopedSelector = (name) => {
  return createSelector(
    (state) => state.productDevelopment.data,
    (products) =>
      products.find(
        (product) =>
          product.name === name && product.status === PRODUCT_DEVELOPMENT_STATES.developed
      )
  )
}
